import api from './api'
import store from '../store/store'

/* eslint-disable no-console, no-irregular-whitespace */
export default {
  fieldTypes: {
    Form: 1,
    MultipleChoice: 2,
    BasicUserInformation: 3,
    Date: 4,
    Integer: 5,
    Address: 6,
    Group: 7,
    Currency: 8,
    Income: 9,
    Assets: 10,
    Agreements: 11,
    Text: 13,
    Expense: 15,
    IncomeLong: 19,
    RepeatingGroup: 21,
    Hidden: 22,
    Boolean: 23,
    Button: 24,
    BorrowerList: 25,
    MilitaryService: 26,
    DemographicsEthnicity: 27,
    DemographicsSex: 28,
    DemographicsRace: 29,
    Percent: 100,
    AccountChekScreen: 500,
    DocusignScreen: 501,
    AgreementScreen: 502,
    Screen: 1000,
    HubScreen: 1001
  },
  textVars: {
    FirstName: 'Bob Bobington'
  },
  listStates: [
    { Value: "AL", Text: "Alabama" },
    { Value: "AK", Text: "Alaska" },
    { Value: "AS", Text: "American Samoa" },
    { Value: "AZ", Text: "Arizona" },
    { Value: "AR", Text: "Arkansas" },
    { Value: "CA", Text: "California" },
    { Value: "CO", Text: "Colorado" },
    { Value: "CT", Text: "Connecticut" },
    { Value: "DE", Text: "Delaware" },
    { Value: "DC", Text: "District Of Columbia" },
    { Value: "FM", Text: "Federated States Of Micronesia" },
    { Value: "FL", Text: "Florida" },
    { Value: "GA", Text: "Georgia" },
    { Value: "GU", Text: "Guam" },
    { Value: "HI", Text: "Hawaii" },
    { Value: "ID", Text: "Idaho" },
    { Value: "IL", Text: "Illinois" },
    { Value: "IN", Text: "Indiana" },
    { Value: "IA", Text: "Iowa" },
    { Value: "KS", Text: "Kansas" },
    { Value: "KY", Text: "Kentucky" },
    { Value: "LA", Text: "Louisiana" },
    { Value: "ME", Text: "Maine" },
    { Value: "MH", Text: "Marshall Islands" },
    { Value: "MD", Text: "Maryland" },
    { Value: "MA", Text: "Massachusetts" },
    { Value: "MI", Text: "Michigan" },
    { Value: "MN", Text: "Minnesota" },
    { Value: "MS", Text: "Mississippi" },
    { Value: "MO", Text: "Missouri" },
    { Value: "MT", Text: "Montana" },
    { Value: "NE", Text: "Nebraska" },
    { Value: "NV", Text: "Nevada" },
    { Value: "NH", Text: "New Hampshire" },
    { Value: "NJ", Text: "New Jersey" },
    { Value: "NM", Text: "New Mexico" },
    { Value: "NY", Text: "New York" },
    { Value: "NC", Text: "North Carolina" },
    { Value: "ND", Text: "North Dakota" },
    { Value: "MP", Text: "Northern Mariana Islands" },
    { Value: "OH", Text: "Ohio" },
    { Value: "OK", Text: "Oklahoma" },
    { Value: "OR", Text: "Oregon" },
    { Value: "PW", Text: "Palau" },
    { Value: "PA", Text: "Pennsylvania" },
    { Value: "PR", Text: "Puerto Rico" },
    { Value: "RI", Text: "Rhode Island" },
    { Value: "SC", Text: "South Carolina" },
    { Value: "SD", Text: "South Dakota" },
    { Value: "TN", Text: "Tennessee" },
    { Value: "TX", Text: "Texas" },
    { Value: "UT", Text: "Utah" },
    { Value: "VT", Text: "Vermont" },
    { Value: "VI", Text: "Virgin Islands" },
    { Value: "VA", Text: "Virginia" },
    { Value: "WA", Text: "Washington" },
    { Value: "WV", Text: "West Virginia" },
    { Value: "WI", Text: "Wisconsin" },
    { Value: "WY", Text: "Wyoming" }
  ],
  loadCompany: function(companyid) {
    if (companyid || false) { 
      return api.send('Company/PublicDetails', {
        CompanyID: companyid
      })
      .then(r => {
        if ((((r || {}).data || {}).Companies || []).length > 0)
          return r.data.Companies[0]
        return null
      })
    }
    else {
      return new Promise(function (resolve, reject) {
        resolve(null)
      })
    }
  },
  loadOfficer: function (companyid, officerid) {
    if ((companyid || false) && (officerid || false)) {
      return api.send('User/PublicProfile', {
        CompanyID: companyid,
        UserID: officerid
      })
      .then(r => {
        if (!!((r || {}).data || {}).Profile)
          return r.data
        return null
      })
    }
    else {
      return new Promise(function (resolve, reject) {
        resolve({
          Profile: null,
          Theme: null,
          Config: null
	})
      })
    }
  },
  searchOfficer: function (name, zip) {
    return api.send('User/PublicList', {
      CompanyID: store.getters.getCompany.CompanyID,
      Search: name,
//      Zip: zip,
      Count: 5
    })
    .then(r => {
       return (r || {}).data
    })
  },
  getConfig: function (companyid, officerid) {
    if (companyid || false) {
      return api.send('Config/General/Lookup', {
        CompanyID: companyid,
        UserID: officerid,
        Compile: true
      })
      .then(r => {
        return ((r || {}).data || {}).Config
      })
    }
    else {
      return new Promise(function (resolve, reject) {
        resolve(null)
      })
    }
  },
  loadForm: function (companyid, officerid, realtorid) {
    var args = {
      FormName: 'Smart1003',
      UserID: officerid,
      CompanyID: companyid
    }

    if (realtorid)
      args.AdditionalData = {
        RealtorID: realtorid
      }

    return api.send('Form/Structure', args)
    .then(r => {
      return this.parseFormData(r)
    })
  },
  loadSave: function (companyid, userid, borrowerid) {
    // const api_url = 'https://api.nextgenpam.com/Form/Load'
    const api_url = process.env.VUE_APP_BASE_URL + 'local-data-savedata.json'
    // const api_url = 'http://localhost:54683/Form/Load'
    return axios
      .get(api_url)
      // .post(api_url, {
      //   FormName: 'Smart1003',
      //   UserID: userid,
      //   CompanyID: companyid,
      //  // BorrowerID: borrowerid
      // })
      .then(response => {
        return response
      })
  },
  submitForm: function (companyid, userid, linkdata, data) {
    return api.send('Form/Submit', {
      FormName: 'Smart1003',
      SubmitData: {
        UserID: userid,
        CompanyID: companyid,
        LoanID: null,
        LinkData: linkdata,
        Values: this.prepareValuesForUpload(data)
      }
    })
    .then(r => {
      return (r || {}).data
    })

	  /*
    // const api_url = 'https://api.nextgenpam.com/Form/Submit'
    // const api_url = process.env.VUE_APP_BASE_URL + 'local-data.json'
    const api_url = 'http://localhost:54683/Form/Submit'
    return axios
      .post(api_url, {
        FormName: 'Smart1003',
        SubmitData: {
          UserID: userid,
          CompanyID: companyid,
          // LoanID: null,
          // LinkData: linkdatatoken,
          Values: this.prepareValuesForUpload(data)
        }
      })
      .then(response => {
        return response
      })
	  */
  },
  prepareValuesForUpload: function (data) {
    var values = []
    for (var p in data) {
      values.push({
        Key: p,
        Value: JSON.stringify(data[p])
      })
    }

    return values
  },
  parseFormData: function (response) {
    if (
      typeof response == 'object' &&
      response.data &&
      response.data.Success
    ) {
      for (
        let section_i = 0;
        section_i < response.data.FormStructure.Fields.length;
        section_i++
      ) {
        response.data.FormStructure.Fields[section_i] = this.parseField(response.data.FormStructure.Fields[section_i])
      }
    }
    return response
  },
  parseField: function (field) {
    if (typeof field === 'object' && field !== null) {
      field.FieldSpan = 4 // 4 is full width (default)

      // Text var replacement
      if (typeof field.Text !== 'undefined') {
        field.Text = this.parseText(field.Text)
      } else {
        field.Text = '< MISSING TEXT >'
      }

      // Description var replacement
      if (typeof field.Description !== 'undefined') {
        field.Description = this.parseText(field.Description)
      }

      // Grid X and Y
      if (
        typeof field.Grid === 'object' &&
        field.Grid !== null &&
        typeof field.Grid.Span !== 'undefined'
      ) {
        field.FieldSpan = field.Grid.Span
      } else {
        field.Grid = false
      }

      // InitialFields
      field.RepeatingFields = false
      if (field.InitialFields === null) field.InitialFields = []
      if (typeof field.InitialFields !== 'undefined' && Array.isArray(field.InitialFields) && field.InitialFields.length) {
        if (typeof field.Fields !== 'undefined' && Array.isArray(field.Fields) && field.Fields.length) {
          console.log('Parsing Error: Found InitialFields as well as Fields.', field)
        } else {
          // Use "Fields" to simplify Vue code, designating a repeating fieldset with RepeatingFields = true
          field.RepeatingFields = true
        }
      }

      // Fields
      if (typeof field.Fields !== 'undefined' && Array.isArray(field.Fields) && field.Fields.length) {
        // Put Fields into rows for v-for statement
        let newFields = []
        let currRow = []
        let currRowSpanCount = 0
        for (let field_i = 0; field_i < field.Fields.length; field_i++) {
          let currField = this.parseField(field.Fields[field_i])
          currRow.push(currField)
          currRowSpanCount += currField.FieldSpan
          if (currRowSpanCount >= 4) {
            newFields.push(currRow)
            currRow = []
            currRowSpanCount = 0
          }
        }
        field.Fields = newFields
      }

      // Body
      if (typeof field.Body !== 'undefined' && Array.isArray(field.Body) && field.Body.length) {
        for (let field_i = 0; field_i < field.Body.length; field_i++) {
          field.Body[field_i] = this.parseField(field.Body[field_i])
          if (typeof field.Layout !== 'undefined' && typeof field.Body[field_i].Layout === 'undefined') {
            field.Body[field_i].Layout = field.Layout
          }
        }
      }

      // InitialFields
      if (typeof field.InitialFields !== 'undefined' && Array.isArray(field.InitialFields) && field.InitialFields.length) {
        for (let field_i = 0; field_i < field.InitialFields.length; field_i++) {
          field.InitialFields[field_i] = this.parseField(field.InitialFields[field_i])
          if (typeof field.Layout !== 'undefined' && typeof field.InitialFields[field_i].Layout === 'undefined') {
            field.InitialFields[field_i].Layout = field.Layout
          }
        }
        if (field.RepeatingFields)
          field.Body = field.InitialFields
      } else if (field.RepeatingFields) {
        field.Body = []
      }

      // SubsequentFields
      if (typeof field.SubsequentFields !== 'undefined' && Array.isArray(field.SubsequentFields) && field.SubsequentFields.length) {
        for (let field_i = 0; field_i < field.SubsequentFields.length; field_i++) {
          field.SubsequentFields[field_i] = this.parseField(field.SubsequentFields[field_i])
          if (typeof field.Layout !== 'undefined' && typeof field.SubsequentFields[field_i].Layout === 'undefined') {
            field.SubsequentFields[field_i].Layout = field.Layout
          }
        }
      }

      return field
    }
    return false
  },
  parseText: function (text) {
    if (typeof text !== 'undefined' && text !== null) {
	    /*
      // Replace text variables
      const re = /{{([^}]+)}}/g
      const matches = text.match(re)
      if (matches) {
        for (let match_i = 0; match_i < matches.length; match_i++) {
          const currVarOriginal = matches[match_i]
          const currVar = matches[match_i].replace(/({{\s?|\s?}})/g, '')
          if (typeof this.textVars[currVar] !== 'undefined') {
            text = text.replace(currVarOriginal, this.textVars[currVar])
          } else {
            console.log('Warning: parseText() variable "' + currVar + '" replacement not found.')
          }
        }
      }
	    */

      // Remove notes
      text = text.replace(/ \(\(.*$/, '')
    }
    return text
  },
  getInputType: function (input_type) {
    if (this.fieldTypes[input_type]) {
      return this.fieldTypes[input_type]
    }
    return this.fieldTypes.Text
  },
  isInput: function (type, input_type) {
    if (
      type == this.fieldTypes.MultipleChoice ||
      type == this.fieldTypes.Boolean ||
      type == this.fieldTypes.Date ||
      type == this.fieldTypes.Integer ||
      type == this.fieldTypes.Address ||
      type == this.fieldTypes.Currency ||
      type == this.fieldTypes.Income ||
      type == this.fieldTypes.Text ||
      type == this.fieldTypes.Expense ||
      type == this.fieldTypes.IncomeLong ||
      type == this.fieldTypes.Percent ||
      type == this.fieldTypes.Agreements
    ) {
      if (typeof input_type !== 'undefined') {
        if (
          input_type == 'text' &&
          (type == this.fieldTypes.Text || type == this.fieldTypes.Address)
        )
          return true
        if (
          input_type == 'currency' &&
          (type == this.fieldTypes.Currency ||
            type == this.fieldTypes.Income ||
            type == this.fieldTypes.IncomeLong ||
            type == this.fieldTypes.Expense)
        )
          return true
        if (
          input_type == 'boolean' &&
          (type == this.fieldTypes.Boolean)
        )
          return true
        if (input_type == 'integer' && type == this.fieldTypes.Integer)
          return true
        if (input_type == 'percent' && type == this.fieldTypes.Percent)
          return true
        if (input_type == 'date' && type == this.fieldTypes.Date) return true
        // if (
        //   input_type == 'ssn' &&
        //   (
        //     type == this.fieldTypes.SocialSecurityNumber
        //   )
        // )
        //   return true
        if (input_type == 'dropdown' && type == this.fieldTypes.MultipleChoice)
          return true
        return false
      }

      return true
    }
    return false
  },
  isGroup: function (type) {
    if (
      type == this.fieldTypes.Group ||
      type == this.fieldTypes.RepeatingGroup
    )
      return true
    return false
  },
  parseInputValue: function (data) {
    if (typeof data == 'object' && typeof data.value !== 'undefined') {
      data.name = typeof data.name == 'undefined' ? '' : data.name
      data.type = typeof data.type == 'undefined' ? false : data.type
      data.required = data.required === true ? true : false
      let parsedValue = data.value + '' // Added + '' to fix Number type values

      // If has a value
      if (parsedValue.length > 0) {
        // Social Security Number
        // if (type == this.fieldTypes.SocialSecurity) {
        if (
          this.isInput(data.type, 'ssn') ||
          (data.type == this.fieldTypes.Text && data.name.includes('_ssn'))
        ) {
          const re = /^([0-9]{3}-?)([0-9]{2}-?)([0-9]{4})$/
          // const re = /^((?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4})|((?!219 09 9999|078 05 1120)(?!666|000|9\d{2})\d{3} (?!00)\d{2} (?!0{4})\d{4})|((?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4})$/
          let isSSN = re.exec(data.value) // Return array, index 0 is the input value, 1 is for dashed, 2 is for spaces, and 3 is for no separators
          if (!isSSN) return false

          // Remove symbols
          parsedValue = parsedValue.replace(/[^0-9]/g, '')

          // Add dashes
          parsedValue = parsedValue.replace(
            /^([0-9]{3})([0-9]{2})([0-9]{4})$/,
            '$1-$2-$3'
          )
        }

        // Zip
        if (
          this.isInput(data.type, 'zip') ||
          (data.type == this.fieldTypes.Text && data.name.includes('_zip'))
        ) {
          const re = /^[0-9]{5}$/
          let isZip = re.exec(data.value)
          if (!isZip) return false

          // Remove non-numbers
          parsedValue = parsedValue.replace(/[^0-9]/g, '')
        }

        // Phone
        if (
          this.isInput(data.type, 'phone') ||
          (data.type == this.fieldTypes.Text && data.name.includes('_phone'))
        ) {
          const re = /^(?:\(?[0-9]{3}\)?\s?)(?:[0-9]{3}\-?)(?:[0-9]{4})$/
          let isPhone = re.exec(data.value)
          if (!isPhone) return false

          // Remove symbols
          parsedValue = parsedValue.replace(/[^0-9]/g, '')

          // Add dashes
          parsedValue = parsedValue.replace(
            /^([0-9]{3})([0-9]{3})([0-9]{4})$/,
            '($1) $2-$3'
          )
        }

        // Email
        if (
          this.isInput(data.type, 'email') ||
          (data.type == this.fieldTypes.Text && data.name.includes('_email'))
        ) {
          // const re = /^[^@]+@[^\.]+\..+$/
          const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          let isEmail = re.exec(data.value)
          if (!isEmail) return false
        }

        // Currency
        if (this.isInput(data.type, 'currency')) {
          const re = /^(?:\$)?(?:[0-9]{1,3}(?:,[0-9]{3})+|\.?[0-9]+)(?:\.[0-9]+|\.)?$/
          let isFloat = re.exec(data.value)
          if (!isFloat) return false

          // Remove symbols (except decimal)
          parsedValue = parsedValue.replace(/[^0-9.]/g, '')

          if (data.value.includes('.')) {
            // Parse Float
            parsedValue = parseFloat(parsedValue)
              .toFixed(2)
              .toString()
          } else {
            // Parse Integer
            parsedValue = parseInt(parsedValue).toString()
          }

          // Add commas
          // parsedValue = parsedValue.replace(/^\B(?=(\d{3})+(?!\d))$/, ',')
          parsedValue = parsedValue.replace(/([0-9])(?=([0-9][0-9][0-9])+(?![0-9]))/g, '$1,')

          // Add dollar sign
          // parsedValue = '$' + parsedValue
        }

        // Integer
        if (this.isInput(data.type, 'integer')) {
          const re = /^[0-9]+$/
          let isInteger = re.exec(data.value)
          if (!isInteger) return false
        }

        // Percentage
        if (this.isInput(data.type, 'percent')) {
          const re = /^(?:[0-9]+|[0-9]+\.|\.[0-9]|[0-9]+\.[0-9])(?:%)?$/
          let isPercent = re.exec(data.value)
          if (!isPercent) return false

          // Remove symbols (except decimal)
          parsedValue = parsedValue.replace(/[^0-9.]/g, '')

          if (data.value.includes('.')) {
            // Parse Float
            parsedValue = parseFloat(parsedValue)
              .toFixed(2)
              .toString()
          }

          // Add percent sign
          parsedValue = parsedValue + '%'
        }

        // Date
        if (this.isInput(data.type, 'date')) {
          const re = /^(?:[0-9]{2}\/?)[0-9]{2}\/?[0-9]{4}$/
          let isDate = re.exec(data.value)
          if (!isDate) return false

          // Remove slashes
          parsedValue = parsedValue.replace(/[^0-9]/g, '')

          // Make sure numbers are within reasonable ranges
          if (parsedValue.substring(0, 2) < 1 || parsedValue.substring(0, 2) > 12)
            return false
          if (parsedValue.substring(2, 4) < 1 || parsedValue.substring(2, 4) > 31)
            return false
          if (parsedValue.substring(4) < 1800)
            return false

          // Add dashes
          parsedValue = parsedValue.replace(
            /^([0-9]{2})([0-9]{2})([0-9]{4})$/,
            '$1/$2/$3'
          )
        }
      }

      // If has no value and is required
      else if (data.required || data.Required) return false

      return parsedValue
    }
    return false
  }
}
